import React, { useCallback, useEffect, useState } from 'react'
import {
    View,
    Text,
    Dimensions,
    TouchableOpacity,
    Image,
    FlatList,
    Keyboard,
    PixelRatio,
} from 'react-native'
import {
    ActivitysModel,
    CampaignModel,
    CampaignRouteModel,
    CampaignScheduleModel,
    CampaignStepsModel,
    CampaignValuesModel,
    ScheduleFormModel,
    StoresListModel,
} from './models/ScheduleModel'
import { Feather } from '@expo/vector-icons'
import theme from '../../../theme'
import {
    colorUnfilled,
    colorFilled,
    colorFilledBis,
    CampaingViewRelevGradient,
} from '../../../themeConstants'
import styles from './CampaignViewStyles'
import { parseDate } from '../customUtils/calculateDates/calculateDates'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { schedulesServices } from '../../../database/schedules.database'
import * as Progress from 'react-native-progress'
import { LinearGradient } from 'expo-linear-gradient'
import { placeholderGeneral } from '../customUtils/Constants'
import { FormsModel, StepsModel } from './models/StoreDetailModel'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { FormProps, useFormContext } from './context/form.context'
import { getForms } from '../../db/posSchedules'
import { CampaignStatus, getStatusMap } from './StatusTagsStores'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { format } from 'date-fns'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { formatDate, getCurrentDateObject } from '../../utils/formatDate.function'
import {
    CONSTANTS_TYPES_STEPS,
    FORM_SCHEDULE_STATUS,
} from './constants/constants.stores'
import { getConection } from '../appBar/context/HeaderContext'
import { getLocation } from '../appBar/context/LocationContext'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_checkin, request_checkout } from '../../services/schedule.services'
import { InputCommentSheet } from './FormItems/InputCommentItem'
import { Ionicons } from '@expo/vector-icons'
import { DistributorItem } from './CreateSchedule'
import { FormSteps } from './FormSteps'
import { useStepsDistributor } from '../../redux/zustand/stepsDistributorStore'

const { width } = Dimensions.get('window')

interface CampaignViewProps {
    campaignValues: CampaignValuesModel[]
    campaignProgress: number
    date: string
    finishDate: string
    form: ScheduleFormModel
    steps?: CampaignStepsModel[]
    schedule_id?: string
    schedule: CampaignScheduleModel
    showAlert: boolean
    selectedDate?: CampaignRouteModel
    selectDay?: (day: any) => void
    scheduleFree?: boolean
    generator: { active: boolean; is_moderator: boolean; title: string }
    buttonDistributor?: StoresListModel
    activities?: ActivitysModel[]
    checkinsDistributor?: (option: string, dataSteps?: any[]) => void
    handleNotifyIncident?: (name: string) => void
    tabSelected?: number
    reportStatus?: number
    showMapButton?: boolean
}

export const CampaignViewDistributor = ({
    campaignValues,
    campaignProgress,
    date,
    finishDate,
    form,
    steps,
    schedule_id,
    schedule,
    showAlert,
    selectedDate,
    selectDay,
    scheduleFree,
    generator,
    buttonDistributor,
    activities,
    checkinsDistributor,
    handleNotifyIncident,
    tabSelected,
    reportStatus,
    showMapButton,
}: CampaignViewProps) => {
    //console.log('🚀 ~ buttonDistributor:', buttonDistributor)
    const { languageFile } = getLanguage()
    const { formsContext } = useFormContext()
    const [showMore, setShowMore] = useState(false)
    const [showMoreMessage, setMoreMessage] = useState(true)
    const [progressRelev, setProgressRelev] = useState(0)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [formsProgress, setFormsProgress] = useState([]) //{ _id: '3241341', progress: 72, name: 'MATUTINO 1.1', date: '12/10/2024 - 11:08 am' }
    const [storesProgress, setStoresProgress] = useState([])
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()

    const setStepsDistri = useStepsDistributor((state) => state.setSteps)
    const navigateToForms = async (index: number) => {
        let navigate = true
        const today = new Date().toISOString().split('T')[0]
        //aca verifico si me deja ir al form o me bloquea un step
        if (steps && steps.length > 0) {
            //PRIMERO BUSCO SI HAY OBJETIVO EN EL AGENDA SINO TOMO EL DE LA CAMP.
            let step = null
            if (
                schedule.additional &&
                schedule.additional.objective &&
                schedule.additional.objective.length > 0
            ) {
                //ARMO EL STEP
                step = {
                    date_init: schedule['date_init'],
                    date_finish: schedule['date_finish'],
                    type: 'objective',
                    checkins:
                        parseInt(schedule.additional.objective[0]['objetive']) +
                        (schedule.additional.stop_by
                            ? schedule.additional.stop_by.length
                            : 0),
                    forms: [
                        {
                            _id: schedule['form_finish']['_id'], //desbloquea el form vespertino
                            status: 2,
                        },
                    ],
                }
            } else {
                step = steps.find(
                    (step) => step.type === CONSTANTS_TYPES_STEPS.OBJECTIVES,
                )
            }
            //me falta validar las fechas
            if (step) {
                const stepDateInit = new Date(step.date_init)
                    .toISOString()
                    .split('T')[0]
                const stepDateFinish = new Date(step.date_finish)
                    .toISOString()
                    .split('T')[0]
                if (
                    stepDateInit <= today &&
                    stepDateFinish >= today &&
                    step.forms.some((item) => item._id === form._id)
                ) {
                    const count =
                        await schedulesServices.get_total_checkin_count(schedule_id)

                    if (count < step.checkins) {
                        navigate = false
                        let title = languageFile.inactive_vespertino
                        let desc =
                            languageFile.activate_survey +
                            `${step.checkins}, total Check-in: ${count}.`
                        let button = languageFile.accept

                        openBottomSheet(
                            <BottomSheetAlert
                                image={require('../../../assets/stores/inactiveVespertino.png')}
                                title={title}
                                desc={desc}
                                button={button}
                                closeBottomSheet={closeBottomSheet}
                            />,
                            ['50%'],
                        )
                    } else {
                        navigate = true
                    }
                }
            }
        }

        if (navigate) {
            await schedulesServices
                .getForm(form._id)
                .then((get_form) => {
                    navigation.navigate('ExecutionView', {
                        forms: [get_form],
                        selectedIndex: index,
                        schedule_id: form.schedule_id,
                    })
                })
                .finally(() => {
                    AsyncStorage.removeItem('hasSeenModalVesp') //cuando hace el matutinoo vesp elimina el item de asyncStorage
                })
                .catch((error) => console.error(error))
        }
    }
    const validateSteps = async (index: number) => {
        try {
            let navigate = true
            const today = new Date().toISOString().split('T')[0]
            //aca verifico si me deja ir al form o me bloquea un step
            if (steps && steps.length > 0) {
                //PRIMERO BUSCO SI HAY OBJETIVO EN EL AGENDA SINO TOMO EL DE LA CAMP.
                let step = null
                if (
                    schedule.additional &&
                    schedule.additional.objective &&
                    schedule.additional.objective.length > 0
                ) {
                    //ARMO EL STEP
                    step = {
                        date_init: schedule['date_init'],
                        date_finish: schedule['date_finish'],
                        type: 'objective',
                        checkins:
                            parseInt(schedule.additional.objective[0]['objetive']) +
                            (schedule.additional.stop_by
                                ? schedule.additional.stop_by.length
                                : 0),
                        forms: [
                            {
                                _id: schedule['form_finish']
                                    ? schedule['form_finish']['_id']
                                    : 'close_day', //desbloquea el form vespertino o cerrar dia
                                status: 2,
                            },
                        ],
                    }
                } else {
                    step = steps.find(
                        (step) => step.type === CONSTANTS_TYPES_STEPS.OBJECTIVES,
                    )
                }
                //me falta validar las fechas
                if (step) {
                    const stepDateInit = new Date(step.date_init)
                        .toISOString()
                        .split('T')[0]
                    const stepDateFinish = new Date(step.date_finish)
                        .toISOString()
                        .split('T')[0]
                    if (stepDateInit <= today && stepDateFinish >= today) {
                        const count =
                            await schedulesServices.get_total_checkin_count(
                                schedule_id,
                            )
                        console.log('🚀 ~ validateSteps ~ count:', count)
                        navigate = false
                        let title, desc, button

                        if (
                            step.forms &&
                            form &&
                            step.forms.length > 0 &&
                            step.forms.some((item) => item._id == form._id)
                        ) {
                            title = languageFile.inactive_vespertino
                            desc =
                                languageFile.activate_survey +
                                `${step.checkins}, total Check-in: ${count}.`
                            button = languageFile.accept
                        } else {
                            title = 'Aun no puedes cerrar dia'
                            desc =
                                'Debes completar los objetivos de tiendas. Objetivos: ' +
                                `${step.checkins}, total Check-in: ${count}.`
                            button = languageFile.accept
                        }
                        if (count < step.checkins) {
                            openBottomSheet(
                                <BottomSheetAlert
                                    image={require('../../../assets/stores/inactiveVespertino.png')}
                                    title={title}
                                    desc={desc}
                                    button={button}
                                    closeBottomSheet={closeBottomSheet}
                                />,
                                ['50%'],
                            )
                        } else {
                            navigate = true
                        }
                    }
                }
            }
            return navigate
        } catch (error) {
            console.error(error)
        }
    }
    const calculateRelevProgress = async () => {
        try {
            if (schedule) {
                const { form_init, form_finish, _id, date_init, date_finish } =
                    schedule
                const form_id_init = form_init?._id
                const form_id_finish = form_finish?._id

                const formInitStatus =
                    await schedulesServices.getFormStatusFromAdvances(
                        _id,
                        form_id_init,
                        {
                            date_init: date_init,
                            date_finish: date_finish,
                        },
                    )
                const formFinishStatus =
                    await schedulesServices.getFormStatusFromAdvances(
                        _id,
                        form_id_finish,
                        {
                            date_init: date_init,
                            date_finish: date_finish,
                        },
                    )
                if (formInitStatus) {
                    let name = await schedulesServices.getFormName(form_id_init)
                    await schedulesServices
                        .getFormsAnswers(_id, form_id_init)
                        .then((form) => {
                            if (form) {
                                setFormsProgress([
                                    {
                                        _id: form_id_init,
                                        name: name,
                                        progress: formInitStatus.progress,
                                        date: formInitStatus.date_init,
                                    },
                                ])
                            }
                        })
                }

                if (formFinishStatus) {
                    const formFinishData = await schedulesServices.getFormsAnswers(
                        _id,
                        form_id_finish,
                    )
                    if (formFinishData) {
                        let name =
                            await schedulesServices.getFormName(form_id_finish)
                        setFormsProgress((prevFormsProgress) => {
                            const exists = prevFormsProgress.some(
                                (form) => form._id === form_id_finish,
                            )
                            if (!exists) {
                                return [
                                    ...prevFormsProgress,
                                    {
                                        _id: form_id_finish,
                                        name: name,
                                        progress: formFinishStatus.progress,
                                        date: formFinishStatus.date_init,
                                        //progress: formFinishData.progress_questions_yes_na,
                                        //date: formFinishData.date_init,
                                    },
                                ]
                            }
                            return prevFormsProgress
                        })
                    }
                }
                if (steps && steps.length > 0) {
                    let step = null
                    if (
                        schedule.additional &&
                        schedule.additional.objective &&
                        schedule.additional.objective.length > 0
                    ) {
                        step = {
                            date_init: schedule['date_init'],
                            date_finish: schedule['date_finish'],
                            type: 'objective',
                            checkins:
                                parseInt(
                                    schedule.additional.objective[0]['objetive'],
                                ) +
                                (schedule.additional.stop_by
                                    ? schedule.additional.stop_by.length
                                    : 0),
                            forms: [
                                {
                                    _id: schedule['form_finish']
                                        ? schedule['form_finish']['_id']
                                        : 'cerrar_dia', //desbloquea el form vespertino
                                    status: 2,
                                },
                            ],
                        }
                    } else {
                        step = steps.find(
                            (step) => step.type === CONSTANTS_TYPES_STEPS.OBJECTIVES,
                        )
                    }
                    if (step) {
                        if (step?.checkins) {
                            const count =
                                await schedulesServices.get_total_checkin_count(_id)
                            const progress = (count / step?.checkins) * 100
                            const roundedProgress = Math.floor(progress)
                            if (roundedProgress <= 100) {
                                setProgressRelev(roundedProgress)
                            } else {
                                setProgressRelev(100)
                            }
                            // else {
                            //     if (progressRelev == 100) {
                            //         if (!formFinishStatus) {
                            //             activeForm()
                            //         }
                            //     }18---100
                            // }    1---
                            // }
                        }
                    }
                }
            }
        } catch (error) {
            console.error(error)
        }
    }

    const getProgresStores = async () => {
        try {
            const statusMap = getStatusMap(languageFile)
            if (schedule_id) {
                await schedulesServices
                    .getProgressStatus(schedule_id, statusMap)
                    .then((items) => {
                        setStoresProgress(items)
                    })
            }
        } catch (error) {
            console.error(error)
        }
    }

    const activeForm = async () => {
        if (schedule) {
            const { form_init, form_finish, _id, date_init, date_finish } = schedule
            const form_id_init = form_init?._id
            const form_id_finish = form_finish?._id
            const formFinishStatus =
                await schedulesServices.getFormStatusFromAdvances(
                    schedule_id,
                    form_id_finish,
                    {
                        date_init: date_init,
                        date_finish: date_finish,
                    },
                )
            if (progressRelev == 100 && !formFinishStatus) {
                let title = languageFile.active_vespertino
                let desc = languageFile.completed_your_mandatory_objectives
                let button = languageFile.complete_now
                let buttonDissmis = languageFile.perform_later

                const goto = async () => {
                    await navigateToForms(-1).then(() => closeBottomSheet(true))
                }

                const hasSeenModal = await AsyncStorage.getItem('hasSeenModalVesp')
                if (!hasSeenModal) {
                    openBottomSheet(
                        <BottomSheetAlert
                            image={require('../../../assets/stores/activeVespertino.png')}
                            title={title}
                            desc={desc}
                            buttonGoto={button}
                            button={buttonDissmis}
                            closeBottomSheet={closeBottomSheet}
                            goto={goto}
                        />,
                        ['50%'],
                    )
                    await AsyncStorage.setItem('hasSeenModalVesp', 'true')
                    //setIsModalSeen(true)
                }
            }
        }
    }

    useEffect(() => {
        // const checkIfModalSeen = async () => {
        //     const hasSeenModal = await AsyncStorage.getItem('hasSeenModalVesp')
        //     setIsModalSeen(!!hasSeenModal)
        // }
        // checkIfModalSeen()

        setFormsProgress([])
        setStoresProgress([])
        setProgressRelev(0)
        // activeForm() // comento ya que no se usa en distribuidores mat y vesp
    }, [selectedDate])

    useEffect(() => {
        calculateRelevProgress()
        getProgresStores()
    }, [formsContext, steps, form, schedule, selectedDate, buttonDistributor])

    const handleOffRoute = () => {
        let title = languageFile.back_to_your_agenda
        let desc = languageFile.return_to_the_current_day
        let button = languageFile.continue
        let buttonDissmis = languageFile.cancel

        const currentDateFormat = formatDate(new Date())

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/stores/returnToAgenda.png')}
                title={title}
                desc={desc + `${currentDateFormat}`}
                buttonGoto={button}
                button={buttonDissmis}
                closeBottomSheet={closeBottomSheet}
                goto={navigateToCurrentDate}
            />,
        )
    }
    const saveItemSteps = async (item) => {
        try {
            setStepsDistri(item)
        } catch (error) {
            console.error('🚀 ~ saveItemSteps ~ error:', error)
        }
    }
    const saveSteps = async (dataSteps: any[], option: string) => {
        try {
            console.log('envio steps y llamo al checkin....', dataSteps.length)
            // await checkIn(true, dataSteps)
            checkinsDistributor && checkinsDistributor(option, dataSteps)
            closeBottomSheet(true)
            //setStatusSteps(CHECKIN_REALIZADO)
        } catch (error) {
            console.error('🚀 ~ saveSteps ~ error:', error)
        }
    }
    const navigateToCurrentDate = () => {
        const currentDateObject = getCurrentDateObject()

        selectDay(currentDateObject)

        closeBottomSheet(true)
    }
    const goToMap = () => {
        console.log('🗺️ [goToMap] Botón presionado')
        console.log('🗺️ [goToMap] Parámetros:', {
            selectedScheduleID: schedule_id,
            campaign_schedule_free: scheduleFree,
            steps: steps?.length,
        })
        if ((form && !form.completed && form.progressive_mode) || showAlert) {
            console.log(
                '⚠️ [goToMap] Bloqueado por form.progressive_mode o showAlert',
            )
        } else {
            console.log('✅ [goToMap] Navegando a MapScreen...')
            navigation.navigate('MapScreen', {
                selectedScheduleID: schedule_id,
                campaign_schedule_free: scheduleFree,
                campaignSteps: steps,
            })
        }
    }

    const ButtoncheckinDistributor = async (option) => {
        if (option == 'close_day') {
            let steps_val = await validateSteps(0)
            if (steps_val) {
                console.log('🚀 ~ ButtoncheckinDistributor ~ steps_val:', steps_val)
                checkinsDistributor && checkinsDistributor(option)
            }
        } else {
            let step_distri = steps.find(
                (t) => t.type === CONSTANTS_TYPES_STEPS.CHECKIN_STEPS_DISTRIBUTOR,
            )
            if (option == 'checkin_distributor' && step_distri) {
                openBottomSheet(
                    <FormSteps
                        fields={step_distri.forms}
                        store_id={null}
                        schedule_id={null}
                        closeBottomSheet={closeBottomSheet}
                        saveSteps={saveSteps}
                        saveItemSteps={saveItemSteps}
                        option={option}
                    />,
                    null,
                    false, //false para que no se pueda cerrar el modal
                )
            } else {
                checkinsDistributor && checkinsDistributor(option)
            }
        }
    }

    const renderDistributorButton = (status) => {
        const statusActions = {
            1: {
                text: 'Check-in',
                action: 'checkin_distributor',
            },
            2: {
                text: 'Salir de bodega',
                action: 'go_field',
            },
            3: {
                text: 'Volver a bodega',
                action: 'return_checkin',
            },
            4: {
                text: 'Cerrar día',
                action: 'close_day',
            },
        }

        const currentAction = statusActions[status]

        if (currentAction) {
            return (
                <TouchableOpacity
                    style={styles.formButton}
                    onPress={() => ButtoncheckinDistributor(currentAction.action)}
                >
                    <Text style={styles.mainButtonText}>{currentAction.text}</Text>
                </TouchableOpacity>
            )
        }

        return null
    }

    const renderProgressContent = (tabSelected) => {
        try {
            if (tabSelected == 2) {
                return (
                    <>
                        {/* Renderiza la barra de progreso normal  (tiendas)*/}
                        <View style={styles.containerProgress}>
                            <Progress.Bar
                                progress={progressRelev / 100}
                                height={12}
                                width={progressRelev > 0 ? width - 76 : width - 48}
                                style={styles.progressBar}
                                color={colorFilledBis}
                                unfilledColor={colorUnfilled}
                            />
                            <TouchableOpacity onPress={() => setShowMore(!showMore)}>
                                <Feather
                                    style={styles.paddingLeft}
                                    name={!showMore ? 'chevron-down' : 'chevron-up'}
                                    size={22}
                                    color={'white'}
                                />
                            </TouchableOpacity>
                        </View>
                        <View
                            style={[
                                styles.containerDailySurvey,
                                { marginRight: progressRelev > 0 ? 32 : 0 },
                            ]}
                        >
                            <Text style={styles.textInfoSurvey}>
                                {languageFile.daily_survey}
                            </Text>
                            <Text style={styles.textProgressSurvey}>
                                {progressRelev} %
                            </Text>
                        </View>
                        {showMore && (
                            <View style={styles.paddingBottom}>
                                <View style={styles.spacer2}></View>
                                <CampaignStatusTags values={storesProgress} />
                            </View>
                        )}
                    </>
                )
            } else if (tabSelected == 1 && activities && activities.length > 0) {
                //render de progress de actividades
                let progressActivity = activities.filter((item) => item.status == 3)
                const count = activities.length
                const progress = (progressActivity.length / count) * 100
                const roundedProgress = Math.floor(progress)

                // Agrupa las actividades por frecuencia
                const activitiesByFrequency = activities.reduce((acc, activity) => {
                    // agrego label en act
                    let label = ''
                    switch (activity.frequency) {
                        case 'day':
                            label = 'diarias'
                            break
                        case 'week':
                            label = 'semanales'
                            break
                        case 'month':
                            label = 'mensuales'
                            break
                        default:
                            label = activity.frequency
                    }
                    if (!acc[activity.frequency]) {
                        acc[activity.frequency] = {
                            label: label,
                            activities: [], //para agrupara las actividades
                        }
                    }
                    acc[activity.frequency].activities.push(activity)
                    return acc
                }, {})

                // Función para calcular el progreso por frecuencia
                const calculateProgress = (activities) => {
                    const completed = activities.activities.filter(
                        (item) => item.status == 3,
                    )
                    return {
                        completedCount: completed.length,
                        totalCount: activities.activities.length,
                        progress: Math.floor(
                            (completed.length / activities.activities.length) * 100,
                        ),
                    }
                }

                const capitalizeFirstLetter = (string) => {
                    return string.charAt(0).toUpperCase() + string.slice(1)
                }

                return (
                    <>
                        {/* Renderiza el progreso general */}
                        <View style={styles.containerProgress}>
                            <Progress.Bar
                                progress={roundedProgress / 100}
                                height={12}
                                width={roundedProgress > 0 ? width - 76 : width - 76}
                                style={styles.progressBar}
                                color={colorFilledBis}
                                unfilledColor={colorUnfilled}
                            />
                            <TouchableOpacity onPress={() => setShowMore(!showMore)}>
                                <Feather
                                    style={styles.paddingLeft}
                                    name={!showMore ? 'chevron-down' : 'chevron-up'}
                                    size={22}
                                    color={'white'}
                                />
                            </TouchableOpacity>
                        </View>
                        <View
                            style={[
                                styles.containerDailySurvey,
                                { marginRight: roundedProgress > 0 ? 32 : 0 },
                            ]}
                        >
                            <Text style={styles.textInfoSurvey}>
                                Actividades totales:{' '}
                            </Text>
                            <Text style={styles.textProgressSurvey}>
                                {progressActivity.length}/{count}
                            </Text>
                        </View>

                        {showMore && (
                            <View>
                                <View style={styles.spacer3}></View>
                                {/* Muestra el progreso para cada tipo de frecuencia que llegue en actividades */}
                                {Object.entries(activitiesByFrequency).map(
                                    ([frequency, activities]) => {
                                        const {
                                            completedCount,
                                            totalCount,
                                            progress,
                                        } = calculateProgress(activities)
                                        return (
                                            <>
                                                <View
                                                    key={frequency}
                                                    style={[
                                                        styles.containerProgress,
                                                        { paddingBottom: 6 },
                                                    ]}
                                                >
                                                    <Progress.Bar
                                                        progress={progress / 100}
                                                        height={8}
                                                        width={
                                                            progress > 0
                                                                ? width - 76
                                                                : width - 76
                                                        }
                                                        style={styles.progressBar}
                                                        color={colorFilledBis}
                                                        unfilledColor={colorUnfilled}
                                                    />
                                                </View>
                                                <View
                                                    style={[
                                                        styles.containerDailySurvey,
                                                        {
                                                            marginRight:
                                                                roundedProgress > 0
                                                                    ? 32
                                                                    : 0,
                                                            paddingBottom: 8,
                                                        },
                                                    ]}
                                                >
                                                    <Text
                                                        style={[
                                                            styles.textInfoSurvey,
                                                            { fontSize: 13 },
                                                        ]}
                                                    >
                                                        {activities.label ===
                                                        'fortnight'
                                                            ? 'Quincenales: '
                                                            : capitalizeFirstLetter(
                                                                  activities.label,
                                                              ) + ':'}
                                                    </Text>
                                                    <Text
                                                        style={[
                                                            styles.textProgressSurvey,
                                                            { fontSize: 13 },
                                                        ]}
                                                    >
                                                        {completedCount}/{totalCount}
                                                    </Text>
                                                </View>
                                            </>
                                        )
                                    },
                                )}
                            </View>
                        )}
                    </>
                )
            } else {
                return null
            }
        } catch (error) {
            console.error(error)
        }
    }

    const fontScale = 1
    const iconSize = 16 * fontScale

    return (
        <View style={styles.container}>
            <LinearGradient
                style={styles.containerCampaignData}
                colors={[
                    theme.colors.linearGradientStart,
                    theme.colors.linearGradientEnd,
                ]}
                start={{ x: 0, y: 0.5 }}
                end={{ x: 1, y: 0.5 }}
            >
                <View style={{ height: 12 }}></View>
                <View
                    style={[
                        styles.containerCampaignHeader,
                        (form && !form.completed && form.progressive_mode) ||
                        showAlert
                            ? { opacity: 0.5 }
                            : null,
                    ]}
                >
                    <View style={[styles.flexDirectionRow, { flex: 2 }]}>
                        <Feather
                            name='truck'
                            size={iconSize}
                            color={'white'}
                            style={styles.marginRight}
                        />
                        <View style={{ width: 4 }}></View>
                        <Text style={styles.textSurvey}>
                            {/* {buttonDistributor && buttonDistributor.name ? buttonDistributor.name : languageFile.your_progress_in_stores} */}
                            {buttonDistributor && buttonDistributor.name
                                ? buttonDistributor.name
                                : 'Progreso del mes'}
                        </Text>
                    </View>
                    <View style={{ width: 20 }}></View>
                    {showMapButton && showMapButton == true && (
                        <TouchableOpacity
                            style={[
                                styles.containerGoToMap,
                                { flex: 1, justifyContent: 'center' },
                            ]}
                            onPress={() => goToMap()}
                        >
                            <Text style={styles.textGoToMap}>
                                {languageFile.map}
                            </Text>
                            <Feather
                                name='map-pin'
                                size={iconSize}
                                color={'white'}
                            />
                        </TouchableOpacity>
                    )}
                </View>
                <Text
                    style={[
                        styles.textInfoSurvey,
                        styles.marginLeftBis,
                        styles.marginRightBis,
                    ]}
                >
                    {buttonDistributor && buttonDistributor.address
                        ? buttonDistributor.address
                        : 'nda'}
                </Text>
                {renderProgressContent(tabSelected)}

                {showAlert ? (
                    <TouchableOpacity
                        activeOpacity={0.7}
                        onPress={() => handleOffRoute()}
                    >
                        <View style={styles.spacer1}></View>
                        <LinearGradient
                            style={[styles.linearGradient, { marginBottom: 15 }]}
                            colors={[
                                theme.colors.colorPrimary,
                                theme.colors.linearGradientStart,
                            ]}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                        >
                            <View style={styles.containerAlert}>
                                <Image
                                    style={styles.alertImage as any}
                                    source={require('../../../assets/stores/alert.png')}
                                />
                                <Text style={[styles.offRoute, { flex: 1 }]}>
                                    {languageFile.off_route}
                                </Text>
                            </View>
                        </LinearGradient>
                    </TouchableOpacity>
                ) : null}

                {buttonDistributor && buttonDistributor.name
                    ? renderDistributorButton(buttonDistributor.status)
                    : null}

                <TouchableOpacity
                    style={{ marginTop: 12 }}
                    onPress={() =>
                        handleNotifyIncident(buttonDistributor.name ?? '')
                    }
                >
                    <Text style={[styles.mainButtonTextBis, { paddingLeft: 0 }]}>
                        Notificar incidencia
                    </Text>
                </TouchableOpacity>

                {form && form?.name && !showAlert ? null : progressRelev &&
                  progressRelev == 100 &&
                  reportStatus != 1 ? (
                    <LinearGradient
                        style={styles.linearGradient}
                        colors={
                            CampaingViewRelevGradient as readonly [string, string]
                        }
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                    >
                        <Feather name='check' size={iconSize} color={'white'} />
                        <Text style={styles.mainButtonTextBis}>
                            {languageFile.reached_your_goal}
                        </Text>
                    </LinearGradient>
                ) : null}
            </LinearGradient>
        </View>
    )
}

export const CampaignCustomBar = ({
    values,
    total,
}: {
    values: CampaignValuesModel[]
    total: number
}) => {
    let width = Dimensions.get('window').width

    return (
        <View style={styles.containerCampaignProgress}>
            {values.map((item, index) => {
                let percentage = (item.value / total) * 100
                let barWidth = (width * percentage) / 100
                let l = console.log(percentage, barWidth)

                return <View style={styles.compaignProgress}></View> //@juli aca me rompe cuando trae la info del local
            })}
        </View>
    )
}
export const CustomBar = ({
    values,
    total,
    progress_color,
}: {
    values: number[]
    total: number
    progress_color: string
}) => {
    let width = Dimensions.get('window').width

    return (
        <View style={styles.containerCampaignProgress}>
            {values.map((item, index) => {
                let percentage = (item / total) * 100
                let barWidth = (width * percentage) / 100

                return (
                    <View
                        style={{ width: barWidth, backgroundColor: progress_color }}
                    ></View>
                )
            })}
        </View>
    )
}
export const CampaignStatusTags = ({
    values,
}: {
    values: CampaignValuesModel[]
}) => {
    // console.log('🚀 ~................... CampaignStatusTags ~ values:', values)
    return (
        <View>
            {values.map((item, index) => {
                return (
                    <View key={index} style={styles.containerReferences}>
                        <View
                            style={[
                                styles.circlesReferences,
                                { backgroundColor: item.color_hex },
                            ]}
                        ></View>
                        <Text style={{ ...styles.textForm, ...styles.marginLeft }}>
                            {item.label} / {item.value}
                        </Text>
                    </View>
                )
            })}
        </View>
    )
}
